/*
 * Copyright (c) 2025 Hardfin, Inc.
 */
import { assetMetadataSchema } from '@/asset/api/types';
import { z } from 'zod';

export const assetMetadataFormSchema = z.object({
  metadata: z.array(assetMetadataSchema),
});

export type AssetMetadataForm = z.infer<typeof assetMetadataFormSchema>;
